<template>
  <a-modal :title="`【${user.name}】的优惠券`"
           :open="modal"
           :width="1200"
           @cancel="cancelCk">
    <div class="nav-el">
      <a-button size="small" type="primary" @click="addCk">补发优惠劵</a-button>
    </div>

    <a-table size="small"
             :columns="columns"
             :dataSource="source"
             :pagination="pagination"
             :loading="loading"
             :onChange="handlePage">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'state'">
          <a-space>
            <a-tag v-if="record.state === 0" :bordered="false" color="red">禁用</a-tag>
            <a-tag v-else-if="record.state === 1" :bordered="false">正常</a-tag>
            <a-tag v-else-if="record.state === 2" :bordered="false" color="green">已使用</a-tag>
            <a-tag v-else :bordered="false" color="red">过期</a-tag>
          </a-space>
        </template>

        <template v-else-if="column.dataIndex === 'time'">
          <div>创建：{{ record.createTime }}</div>
          <div>过期：{{ record.expiredTime }}</div>
          <div>使用：{{ record.usedTime }}</div>
        </template>

        <template v-else-if="column.dataIndex === 'act'">
          <a-button v-if="record.state === 1" danger @click="callbackCk(record)" size="small">召回</a-button>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>

    <template #footer></template>
  </a-modal>

  <add-coupon-modal ref="addCoupon" @refresh="query"/>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message, Modal} from 'ant-design-vue'

import AddCouponModal from '@/views/user/AddCoupon.vue'

const modal = ref(false)
const loading = ref(false)

const source = ref([])

const user = ref({})
const pagination = ref({
  showSizeChanger: true,
  defaultCurrent: 1,
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  total: 0,
  onShowSizeChange: (current, size) => {
    pagination.value.current = 1
    pagination.value.pageSize = size
    query()
  }
})

const addCoupon = ref(null)

const columns = [
  {
    key: 'name',
    title: '优惠券',
    dataIndex: 'name',
  }, {
    key: 'price',
    title: '价值 [元]',
    dataIndex: 'price',
  }, {
    key: 'item',
    title: '限定',
    dataIndex: 'item',
  }, {
    key: 'source',
    title: '来源',
    dataIndex: 'source',
  }, {
    key: 'orderId',
    title: '订单',
    dataIndex: 'orderId',
  }, {
    key: 'state',
    title: '状态',
    dataIndex: 'state',
  }, {
    key: 'time',
    title: '时间',
    dataIndex: 'time',
  }, {
    key: 'act',
    title: '操作',
    dataIndex: 'act',
  }
]

function query() {
  loading.value = true

  axios.get(`/user/${user.value.id}/coupon`, {
    params: {
      page: pagination.value.current,
      size: pagination.value.pageSize,
    }
  }).then((res) => {
    loading.value = false

    if (res.code === 1) {
      pagination.value.current = res.data.page
      pagination.value.total = res.data.total
      source.value = res.data.data
    }

    modal.value = true
  })
}

function handlePage(param) {
  pagination.value.current = param.current
  pagination.value.pageSize = param.pageSize
  query()
}

function openCk(record) {
  user.value = record
  pagination.value.current = 1
  query()
}

function cancelCk() {
  modal.value = false
  loading.value = false
}

function addCk() {
  addCoupon.value.openCk(user.value.id)
}

function callbackCk(record) {
  Modal.confirm({
    title: '确定召回吗？',
    content: '将之前发放给用户的优惠劵作废',
    okText: '确定',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      axios.post(`/coupon/${record.id}/callback`).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

defineExpose({openCk})
</script>

<style scoped>
.nav-el {
  text-align: right;
  margin-bottom: 10px;
}
</style>